import { Component, OnInit, AfterViewInit, OnDestroy, Input, ElementRef, Directive, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

import { BaseComponent } from '../../../../_base/base.component';
import { Settings } from '../../../../app.settings.model';
import { Question, QuestionOption, QuestionOptionPossible } from '../../../../_models';
import { QuestionType } from 'src/app/_enums';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-question-type-fill-in-blank',
  templateUrl: './question-type-fill-in-blank.component.html',
  styleUrls: ['./question-type-fill-in-blank.component.scss']
})
export class QuestionTypeFillInBlankComponent extends BaseComponent implements OnInit, OnDestroy {


  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup;
  @Input('viewOnly') viewOnly = false;

  @ViewChild('textareaRef') descriptionEml: ElementRef;
  isDescriptionChanging = false;
  descriptionValueChanges: Subscription;
  constructor(private fb: FormBuilder) {
    super();
  }
 
  get options(): FormArray {
    if (!this.formGroup)
      return null;
    return this.formGroup.get('options') as FormArray;
  }
  get description(): FormControl {
    return this.formGroup.get('description') as FormControl;
  }

  ngOnInit() {
    this.formGroup.reset();
    this.formGroup.addControl('options', this.fb.array([]));
    this.formGroup.addControl('description', this.fb.control(
      this.question && this.question.questionType === QuestionType.FillInBlanks ? 
      this.question.description : 
      this.formGroup.parent.get('description').value,
      [Validators.required, Validators.pattern(/(\[[^[\]\r\n]+\])+/)]
    ));
    this.options.controls.length = 0;

    if (this.question && this.question.options && this.question.options.length > 0) {
      _.forEach(this.question.options, o => this.options.push(this.createOptionGroup(o)));
    }
    this.descriptionChange(this.description.value);

    this.descriptionValueChanges = this.description.valueChanges.subscribe((value: string) => {
      this.descriptionChange(value);
    });

    if (this.viewOnly)
      this.formGroup.disable();
  }
  ngOnDestroy() {
    if (this.descriptionValueChanges)
      this.descriptionValueChanges.unsubscribe();
  }


  createOptionGroup(option: QuestionOption): FormGroup {
    const group = this.fb.group({
      id: option ? option.questionOptionId : 0,
      title: [option ? option.title : '', [Validators.required]],
      isCaseSensitive: [option ? option.isCaseSensitive : false, [Validators.required]],
      possibles: this.fb.array([])
    });
    _.forEach(option.possibles, p => this.getOptionPossiblesArray(group).push(this.createPossibleGroup(p)));
    return group;
  }

  createPossibleGroup(possible: QuestionOptionPossible): FormGroup {
    const group = this.fb.group({
      id: possible ? possible.questionOptionPossibleId : 0,
      title: [possible ? possible.title : '', [Validators.required]],
      isCaseSensitive: [possible ? possible.isCaseSensitive : false, [Validators.required]],
    });
    return group;
  }

  getOptionPossiblesArray(optionGroup: FormGroup): FormArray {
    if (!optionGroup)
      return null;
    return optionGroup.get('possibles') as FormArray;
  }


  descriptionChange(descriptionValue: string) {
    if (this.isDescriptionChanging)
      return;

    if (!descriptionValue) {
      while (this.options.length)
        this.options.removeAt(0);
      return;
    }

    this.isDescriptionChanging = true;

    let caretPosition;

    if (this.descriptionEml.nativeElement)
      caretPosition = this.descriptionEml.nativeElement.selectionStart;


    const valueArr = (descriptionValue).split(/(\[[^[\]\r\n]+\])+/);
    const optionsStrings: string[] = [];

    for (let i = 0; i < valueArr.length; i++) {
      if (!(valueArr[i].startsWith('[') && valueArr[i].endsWith(']')))
        continue;

      valueArr[i] = `[${valueArr[i].slice(1, -1).trim().replace(/  +/g, ' ')}]`;

      if (valueArr[i].length === 2)
        valueArr[i] = '[ ]';

      optionsStrings.push(valueArr[i]);
    }

    this.description.setValue(valueArr.join(''));

    if (this.descriptionEml.nativeElement)
      this.descriptionEml.nativeElement.selectionEnd = caretPosition;

    for (let i = 0; i < optionsStrings.length; i++) {
      if (this.options.at(i)) {
        this.options.at(i).get('title').setValue(optionsStrings[i]);
      } else {
        this.options.push(this.fb.group({
          id: 0,
          title: [optionsStrings[i]],
          isCaseSensitive: [false],
          possibles: this.fb.array([])
        }));
      }
    }
    while (this.options.length > optionsStrings.length) {
      this.options.removeAt(this.options.length - 1);
    }
    this.isDescriptionChanging = false;
  }

  addOptionPossible(optionGroup: FormGroup) {
    this.getOptionPossiblesArray(optionGroup).push(
      this.fb.group({
        id: 0,
        title: ['[]', [Validators.required, Validators.pattern(/^\[((\s)|(\S)|(\S\S)|(\S.+\S))\]$/)]],
        isCaseSensitive: [false, [Validators.required]],
      })
    );
  }
}


